import { MAX_ZOOM, ZoomLevel } from "@zapier/canvas-constants";

export default function getNextZoomInLevel(
  currentZoom: number,
  zoomLevels: ZoomLevel[],
): ZoomLevel {
  const possibleLevels = zoomLevels.filter((level) => level > currentZoom);
  return (
    possibleLevels.length > 0 ? Math.min(...possibleLevels) : MAX_ZOOM
  ) as ZoomLevel;
}
